"use client";

import { useEffect } from "react";
import { captureErrorBoundary } from "@/lib/utils/captureErrorBoundary";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureErrorBoundary(error, "global");
  }, [error]);

  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-gradient-purple">
          <div className="text-center p-8 max-w-md">
            <h1 className="text-4xl font-bold text-(--gold) mb-4">Something went wrong</h1>
            <p className="text-(--text-on-purple-secondary) mb-6">
              We apologize for the inconvenience. An error has occurred and our team has been notified.
            </p>
            <button
              onClick={reset}
              className="px-6 py-3 bg-(--brand) text-(--text-on-pink) rounded-lg hover:bg-(--brand-dark) transition-colors font-semibold"
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
